export default "__VITE_ASSET__BthXuNrW__"